import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps, Switch } from 'react-router'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import BaseNoteOverview from '../v2/pages/Note/BaseNoteOverview'

export const noteBaseUrl = '/note/:action?'

export default function Notes(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={noteBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Switch>
                    <Route
                        path={route}
                        render={(routeProps: RouteComponentProps) => (
                            <BaseNoteOverview
                                {...routeProps}
                                fileId={props.currentFile?.id}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockNoteOverview-${props.currentFile?.id}-`}
                            />
                        )}
                    />
                </Switch>
            )}
        </EntityPage>
    )
}
